var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"docked-class",rawName:"v-docked-class"}],staticClass:"wrapper",class:_vm.backgroundClass,attrs:{"id":"app"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }